import React, { useEffect, useState } from 'react';

import { toast, ToastContainer } from 'react-toastify';

import { getData, postData } from '../../helpers/postData';
import setErrorHandler from '../../helpers/setErrorHandler';
import SkeletonLoader from '../../components/stateless/Skeleton';
import PageTitle from '../../components/stateless/PageTitle';
import BmeLandingForm from '../../components/statefull/BmeLandingForm';

import './index.scss';
import { format } from 'date-fns';

function RequestDemo() {
  const [formFields, setFormFields] = useState([]);
  const [reset, setReset] = useState(false);
  const [showV2, setShowV2] = useState(false);

  const checkFormValidity = (e) => {
    const res = setErrorHandler(formFields, e);

    setFormFields(res);

    return new Promise((resolve) => {
      resolve(!res.find(item => item.hasError));
    })
  }

  const submitHandler = async (e) => {
    const res = await checkFormValidity(e);

    if (res) {
      postData('/demo-requests', { ...e, meetingDate: format(e.meetingDate, 'dd-MM-yyyy HH:mm') }, false).then(res => {
        if (res.data) {
          if (res.data.passed) {
            setReset(true);

            setTimeout(() => {
              setReset(false);
            }, 1000);

            toast('Done');
            setShowV2(false);
          } else {
            setShowV2(true);
          }
        }
      })
    }
  };

  useEffect(async () => {
    const res = await getData('/demo-requests/demo-subjects');

    setFormFields([
      {
        name: 'Full Name',
        type: 'text',
        slug: 'name',
        validation: {
          min: 5,
          max: 50,
          regex: /[a-zA-Z0-9_s-]+$/,
          error: 'Enter valid name',
          required: true,
        }
      },
      {
        name: 'Email',
        type: 'email',
        slug: 'email',
        validation: {
          required: true,
          regex: /^([a-z0-9_\.-]+)@([\da-z0-9\.-]+)\.([a-z\.]{2,32})$/i,
          error: 'Enter valid E-mail',
        }
      },
      {
        name: 'Date and Time',
        type: 'dateTime',
        slug: 'meetingDate',
        validation: {
          error: 'Mon-Fri 09:00-18:00 GMT+04:00',
          required: true,
          hint: 'Mon-Fri 09:00-18:00 GMT+04:00'
        }
      },
      {
        name: 'Demo Subject',
        type: 'select',
        slug: 'demoSubjects',
        list: res.data,
        multiple: true,
        validation: {
          error: 'Enter valid input',
          required: true
        }
      },
      {
        name: 'Type a request summary',
        type: 'textarea',
        slug: 'message',
        validation: {
          min: 5,
          max: 1024,
          required: true,
          regex: /[a-zA-Z0-9,:._s-]+$/,
          error: 'Enter valid input'
        }
      },
    ]);
  }, [getData]);

  return (
    <>
      <PageTitle heading="Request Demo"
                 description="Explore BetConstruct’s acclaimed iGaming console SpringBME before you plunge into creating and managing operations.
Fill in your details to request a demo. Wait till you hear from us. Then enjoy your test drive." />
      <div className="page-content">
        {formFields.length
          ? <BmeLandingForm showV2={showV2} reset={reset} formFields={formFields} submitText="Send"
                         onSubmit={submitHandler}/>
          : <SkeletonLoader />
        }
      </div>
      <ToastContainer hideProgressBar={true} />
    </>
)};

export default RequestDemo;
